var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6524 10.1111C23.2254 7.13489 20.8652 4.77472 17.889 4.34772V10.1111H23.6524ZM24.6942 12.0547H16.9172C16.3805 12.0547 15.9442 11.6207 15.9442 11.0829V3.30472C15.9442 2.76805 16.3805 2.33289 16.9172 2.33289C21.7414 2.33289 25.6672 6.25872 25.6672 11.0829C25.6672 11.6207 25.2309 12.0547 24.6942 12.0547ZM15.0902 13.9738H24.5974C25.2297 13.9738 25.7244 14.5245 25.6614 15.1533C25.0267 21.4837 19.3427 26.3277 12.695 25.5927C7.34586 25.0023 2.99769 20.6542 2.40619 15.305C1.67352 8.65733 6.51519 2.97216 12.8467 2.33866C13.4767 2.27566 14.0262 2.76916 14.0262 3.40149V12.911C14.0262 13.4978 14.5022 13.9738 15.0902 13.9738Z",
    fill: "#FFFFFF99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_674_4807",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6524 10.1111C23.2254 7.13489 20.8652 4.77472 17.889 4.34772V10.1111H23.6524ZM24.6942 12.0547H16.9172C16.3805 12.0547 15.9442 11.6207 15.9442 11.0829V3.30472C15.9442 2.76805 16.3805 2.33289 16.9172 2.33289C21.7414 2.33289 25.6672 6.25872 25.6672 11.0829C25.6672 11.6207 25.2309 12.0547 24.6942 12.0547ZM15.0902 13.9738H24.5974C25.2297 13.9738 25.7244 14.5245 25.6614 15.1533C25.0267 21.4837 19.3427 26.3277 12.695 25.5927C7.34586 25.0023 2.99769 20.6542 2.40619 15.305C1.67352 8.65733 6.51519 2.97216 12.8467 2.33866C13.4767 2.27566 14.0262 2.76916 14.0262 3.40149V12.911C14.0262 13.4978 14.5022 13.9738 15.0902 13.9738Z",
    fill: "#FFFFFF99"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_674_4807)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/iconReport.a9a94d79fc7a1de1391d550e40204368.svg";
export { ForwardRef as ReactComponent };